import { useMemo } from "react";
import { useTheme } from "@fluentui/react/lib/Theme";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

const classNames = {
  fieldName: `SuggestionFieldName`,
  translation: `SuggestionTranslation`,
  root: `SuggestionRoot`,
  highlight: `SuggestionHighlight`
};

export function useSuggestionStyles() {
  const { semanticColors } = useTheme();
  return useMemo(
    () => mergeStyleSets({
      root: [
        classNames.root,
        {
          background: semanticColors.menuBackground,
          color: semanticColors.listText,
          cursor: `pointer`,
          padding: `10px`,
          width: `100%`,
          selectors: {
            ":hover, :focus, :active": {
              background: semanticColors.menuItemBackgroundHovered,
              color: semanticColors.menuItemTextHovered,
              boxShadow: `none !important`,
              textDecoration: `none !important`,
              outline: `none !important`
            }
          }
        }
      ],
      fieldName: [classNames.fieldName, {}],
      translation: [
        classNames.translation,
        {
          marginBottom: `3px`
        }
      ],
      highlight: [
        classNames.highlight,
        {
          fontWeight: `bold`
        }
      ]
    }),
    [semanticColors]
  );
}
